(function() {
    'use strict';

    angular.module('settings')
        .controller('MessagesUpdateController', MessagesUpdateController);

    MessagesUpdateController.$inject = ['$state', 'contactDataService', 'notificationSrvc', 'messagesMessagesConst', 'competenceDataSrvc', 'userStorageSrvc', 'adminDataSrvc', 'checkModelPermissionsSrvc', 'messagesPermissionsConst', 'clientDataSrvc', 'orderDataSrvc', 'clientContactStatusConst', 'contactSrvc', 'searchFilterSrvc', 'errorNotificationSrvc'];

    function MessagesUpdateController($state, contactDataService, notificationSrvc, messagesMessagesConst, competenceDataSrvc, userStorageSrvc, adminDataSrvc, checkModelPermissionsSrvc, messagesPermissionsConst, clientDataSrvc, orderDataSrvc, clientContactStatusConst, contactSrvc, searchFilterSrvc, errorNotificationSrvc) {
        var self = this;
        var user = userStorageSrvc.getUser();

        self.serverErrors = {
            responsible_person: [],
            competency: [],
            complaint_reason: [],
            nonFieldErrors: []
        };
        self.clientContactData = {};

        self.newMessageServerErrors = {
            user: [],
            content: [],
            conversation: []
        };
        self.newMessage = {
            user: user.pk,
            content: '',
            conversation: $state.params.pk
        };
        self.messageData = {
            files: []
        };

        self.admins = [];
        self.clients = [];
        self.competences = [];
        self.competencesReclamationReason = [];
        self.clientOrders = [];
        self.clientOrderProducts = [];

        self.updateClientContact = updateClientContact;
        self.closeClientContact = closeClientContact;
        self.isClientContactOpen = isClientContactOpen;
        self.cleanErrors = cleanErrors;

        self.onClientSearch = onClientSearch;
        self.onClientChange = onClientChange;
        self.onClientOrderChange = onClientOrderChange;
        self.isNotReclamation = isNotReclamation;

        self.hasPermissionViewMessage = hasPermissionViewMessage;
        self.hasPermissionAddMessage = hasPermissionAddMessage;
        self.sendMessage = sendMessage;

        activate();

        function activate() {
            getClientContact().then(function(response) {
                readMessages();
                return response;
            }).then(function(response) {
                return getClientOrders(self.clientContactData.client);
            }).then(function(response) {
                return getClientOrderProducts(self.clientContactData.order);
            });

            getAdmins();
            getClients();
            getCompetences();
            getCompetencesReclamationReason();
        }

        function updateClientContact() {
            contactDataService.update({
                pk: self.clientContactData.pk
            }, self.clientContactData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", messagesMessagesConst.update);
                    $state.go('layout.messages.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function closeClientContact() {
            contactDataService.update({
                pk: self.clientContactData.pk
            }, {
                status: clientContactStatusConst.close
            }).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", messagesMessagesConst.update);
                    $state.go('layout.messages.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function isClientContactOpen() {
            return self.clientContactData.status === clientContactStatusConst.open ||
                self.clientContactData.status === clientContactStatusConst.new;
        }

        function getClientContact() {
            return contactDataService.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.clientContactData = response;
                console.log(response);
                return response;
            });
        }

        function getAdmins() {
            return adminDataSrvc.clientContact().$promise.then(
                function(response) {
                    self.admins = response;
                    return response;
                }
            );
        }

        function getClients() {
            return clientDataSrvc.clientContactClients({
                client_contact_pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.clients = response.results;
                    return response;
                }
            );
        }

        function onClientSearch(params) {
            if (!params) {
                params = {};
            }
            params.client_contact_pk = $state.params.pk;
            return clientDataSrvc.clientContactClients(
                params
            ).$promise;
        }

        function onClientChange() {
            getClientOrders(self.clientContactData.client);
            self.cleanErrors('client');
        }

        function getCompetences() {
            return competenceDataSrvc.clientContactList({
                complaint_reason: searchFilterSrvc.getCheckboxFilterValue(false)
            }).$promise.then(
                function(response) {
                    self.competences = response;
                    return response;
                }
            );
        }

        function getCompetencesReclamationReason() {
            return competenceDataSrvc.clientContactList({
                complaint_reason: searchFilterSrvc.getCheckboxFilterValue(true)
            }).$promise.then(
                function(response) {
                    self.competencesReclamationReason = response;
                    return response;
                }
            );
        }

        function getClientOrders(client_pk) {
            return orderDataSrvc.clientContact({
                client_pk: client_pk
            }).$promise.then(
                function(response) {
                    self.clientOrders = response;
                    if (self.clientContactData.competency_negotiations) {
                        self.clientOrders.push({
                            pk: self.clientContactData.order
                        })
                    }
                    return response;
                }
            );
        }

        function onClientOrderChange() {
            getClientOrderProducts(self.clientContactData.order);
            self.cleanErrors('order');
        }

        function getClientOrderProducts(order_pk) {
            var order = self.clientOrders.find(function(item) {
                return item.pk === order_pk;
            });

            if (order) {
                self.clientOrderProducts = order.order_products;
            } else {
                self.clientOrderProducts = [];
            }
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function isNotReclamation() {
            var competency = self.competences.find(function(item) {
                return item.pk === self.clientContactData.competency;
            });
            return !(competency && competency.reclamation) || !competency;
        }

        function hasPermissionViewMessage() {
            return !checkModelPermissionsSrvc.isDenied(
                messagesPermissionsConst.view);
        }

        function hasPermissionAddMessage() {
            return !checkModelPermissionsSrvc.isDenied(
                messagesPermissionsConst.add);
        }

        function sendMessage() {
            contactDataService.sendMessage(
                self.newMessage
            ).$promise.then(
                function(response) {
                    contactSrvc.addMessageFiles(response.pk, self.messageData.files)
                        .then(function(response_files) {
                            self.newMessage.content = '';
                            self.messageData.files = [];
                            getClientContact();
                            notificationSrvc.notification("success", messagesMessagesConst.send);
                        });
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function readMessages() {
            for (var i = 0; i < self.clientContactData.conversation_messages.length; ++i) {
                var message = self.clientContactData.conversation_messages[i];
                if (message.is_new && !message.user_is_admin) {
                    readMessage(message);
                }
            }
        }

        function readMessage(message) {
            return contactDataService.readMessage({
                pk: message.pk
            }, {
                is_new: false
            }).$promise.then(
                function(response) {
                    message.is_new = false;
                    return response;
                }, function(response) {
                    notificationSrvc.notification("error", response.data.nonFieldErrors[0]);
                }
            );
        }
    }
})();
